module.exports = __webpack_public_path__ + "static/media/banking-circle.c9806eab.svg";